/*
 * EU-Mitteilung zur gesetzlichen Gewaehrleistung im Warenkorb-Drawer (O-57 Teil 1)
 *
 * Der Drawer ist ein Horizon-Snippet (snippets/cart-drawer.liquid) ohne Platz fuer eigene
 * Bloecke. Statt ihn zu aendern (Update-Schuld), setzt dieses Modul die Mitteilung von aussen
 * ein: Die Vorlage kommt aus dem Block zw-gewaehrleistung im Fussbereich (Einstellung
 * "Im Warenkorb-Drawer"), eingesetzt wird sie als LETZTES Element der Summenbox (.cart-totals),
 * also unter der Preiszeile "Inkl. MwSt., versandkostenfrei ..." und direkt ueber dem
 * Kasse-Knopf samt PayPal-Express und Co. (.cart__ctas folgt auf .cart-totals,
 * snippets/cart-summary.liquid:11-260).
 *
 * Warum am Ende der Summenbox und nicht direkt vor .cart__ctas: Horizon gleicht den Drawer nach
 * jeder Warenkorb-Aenderung mit dem Server-HTML ab (assets/morph.js, updateChildren). Ein fremder
 * Knoten MITTEN in der Liste bringt den Abgleich dazu, die folgenden Geschwister umzuhaengen -
 * vor .cart__ctas hiesse das: Kasse-Knopf und Express-Knoepfe (iframes) werden nach jeder
 * Mengenaenderung neu eingehaengt und neu geladen. Ein Knoten AM ENDE wird nur entfernt
 * (morph.js:598-602), die anderen bleiben unberuehrt. Der MutationObserver setzt die Mitteilung
 * danach sofort wieder ein - vor dem naechsten Bildaufbau, also ohne sichtbares Flackern. Die
 * Pruefung "steht schon da?" verhindert eine Endlosschleife. Eigenes Tag <zw-gewaehrleistung>,
 * damit der Abgleich den Knoten nie mit einem Horizon-<div> paart.
 *
 * Abhaengig von Horizons Namen #cart-drawer und .cart-totals - beim Horizon-Update pruefen
 * (STATUS.md Abschnitt 4).
 */
const vorlage = document.querySelector('template[data-zw-gewaehrleistung-drawer]');
const drawer = document.getElementById('cart-drawer');

if (vorlage && drawer) {
  const einsetzen = () => {
    for (const summe of drawer.querySelectorAll('.cart-totals')) {
      if (summe.lastElementChild?.localName === 'zw-gewaehrleistung') continue;
      summe.querySelector(':scope > zw-gewaehrleistung')?.remove();
      summe.append(vorlage.content.cloneNode(true));
    }
  };

  einsetzen();
  new MutationObserver(einsetzen).observe(drawer, { childList: true, subtree: true });
}
